import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["src", "size", "alt", "hasBorder"];
import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';
import { variant } from 'styled-system';
import { useTheme } from '../../hooks/useTheme';
import { Image } from '../Image';
import { Box } from '../Layout';
const avatarSizes = variant({
  scale: 'avatarSizes',
  prop: 'size'
});
const AvatarWrapper = styled(Box).withConfig({
  displayName: "AvatarWrapper",
  componentId: "sc-19q3h86-0"
})(["&&&{", "}"], avatarSizes);
const Placeholder = styled(Box).withConfig({
  displayName: "Placeholder",
  componentId: "sc-19q3h86-1"
})(["&&&{", " background:linear-gradient(120deg,rgba(232,236,242,0.8) 0%,rgba(245,247,251,0.6) 90%);}"], avatarSizes);
export const Avatar = props => {
  const {
      src,
      size,
      alt,
      hasBorder
    } = props,
    rest = _objectWithoutProperties(props, _excluded);
  const {
    avatarSizes: sizes
  } = useTheme();
  const {
    width,
    height
  } = sizes[size];
  const border = hasBorder ? '2px solid #fff' : 'none';
  return React.createElement(AvatarWrapper, _extends({
    size: size
  }, rest), src ? React.createElement(Image, {
    src: src,
    fixed: {
      width,
      height
    },
    style: {
      border,
      borderRadius: '100%'
    },
    alt: alt
  }) : React.createElement(Placeholder, {
    size: size,
    borderRadius: 7,
    border: border
  }));
};
Avatar.propTypes = process.env.NODE_ENV !== "production" ? {
  hasBorder: PropTypes.bool,
  src: PropTypes.string,
  alt: PropTypes.string,
  size: PropTypes.oneOf(['nano', 'micro', 'tiny', 'small', 'medium', 'large', 'huge'])
} : {};
Avatar.defaultProps = {
  hasBorder: false,
  src: '',
  alt: '',
  size: undefined
};